module.exports = __webpack_public_path__ + "static/img/tu.2af8f4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/tu.png
// module id = gqL1
// module chunks = 1